import { RSocketClient, BufferEncoders, MESSAGE_RSOCKET_COMPOSITE_METADATA, createBuffer, toBuffer } from "rsocket-core";
import RSocketWebSocketClient from "rsocket-websocket-client";
import { Flowable } from "rsocket-flowable";
import { createMetadata, createSetupMetadata } from "../../utils/metadataUtils";
const EMPTY_PAYLOAD = createBuffer(0);
export const RSocketClientSetup = {
    async init ({ token, channels, streams }) {
        const client = createRSocketClient(token);
        // RSocket 연결 후 채널 및 스트림 설정
        const rsocket = await client.connect();
        // 채널 설정
        channels?.forEach(({ sourceRef, onNext })=>{
            setupRequestChannel(rsocket, sourceRef, onNext);
        });
        // 스트림 설정
        streams?.forEach(({ endpoint, onNext })=>{
            setupRequestStream(rsocket, endpoint, token, onNext);
        });
        return rsocket; // rsocket 객체 반환
    },
    sendMessage (sourceRef, message, metadata) {
        const payload = toJsonBuffer(message);
        sourceRef?.current.onNext({
            data: payload,
            metadata
        });
    },
    sendEvent (rsocket, endpoint, data) {
        if (rsocket) {
            rsocket.fireAndForget({
                data: toJsonBuffer(data),
                metadata: createMetadata(endpoint)
            });
        }
    }
};
// Helper function to create an RSocketClient instance
function createRSocketClient(token) {
    return new RSocketClient({
        transport: new RSocketWebSocketClient({
            url: process.env.NEXT_PUBLIC_RSOCKET_URL || 'wss://chat.ugot.uk/rsocket'
        }, BufferEncoders),
        setup: {
            dataMimeType: "application/json",
            metadataMimeType: MESSAGE_RSOCKET_COMPOSITE_METADATA.toString(),
            keepAlive: 5000,
            lifetime: 60000,
            payload: {
                data: EMPTY_PAYLOAD,
                metadata: token ? createSetupMetadata(token) : createSetupMetadata()
            }
        }
    });
}
// Helper function to set up a request channel
function setupRequestChannel(rsocket, sourceRef, onNext) {
    rsocket.requestChannel(new Flowable((source)=>{
        sourceRef.current = source;
        source.onSubscribe({
            cancel: ()=>{},
            request: (n)=>{}
        });
    })).subscribe({
        onComplete: ()=>console.log("requestChannel onComplete"),
        onSubscribe: (subscription)=>{
            subscription.request(1000);
            console.log("requestChannel onSubscribe");
        },
        onError: (error)=>console.log("requestChannel error: ", error),
        onNext: (payload)=>{
            const data = parseData(payload);
            onNext(data);
        }
    });
}
function parseData(payload) {
    try {
        return JSON.parse(payload.data?.toString?.() ?? "null");
    } catch (error) {
        console.error("JSON parsing error:", error);
        return null;
    }
}
function setupRequestStream(rsocket, endpoint, token, onNextMessage) {
    rsocket.requestStream({
        data: EMPTY_PAYLOAD,
        metadata: createMetadata(endpoint, token || "")
    }).subscribe({
        onComplete: ()=>console.log("requestStream onComplete"),
        onSubscribe: (subscription)=>{
            subscription.request(1000);
            console.log("requestStream onSubscribe");
        },
        onError: (error)=>console.log("requestStream error: ", error),
        onNext: (e)=>{
            try {
                const message = JSON.parse(e.data?.toString?.() ?? "null");
                if (onNextMessage) {
                    onNextMessage(message);
                }
            } catch (error) {
                console.error("JSON parsing error:", error);
            }
        }
    });
}
function createPayload(message) {
    return toJsonBuffer(message);
}
function toJsonBuffer(payload) {
    if (payload && typeof payload.copy === "function" && typeof payload.length === "number") {
        return payload;
    }
    if (payload instanceof Uint8Array) {
        return toBuffer(payload);
    }
    if (typeof payload === "string") {
        return toBuffer(payload, "utf8");
    }
    return toBuffer(JSON.stringify(payload ?? {}), "utf8");
}
